var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceiveSendTermPayment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8701",
    "data-name": "Rectangle 8701",
    width: 17.447,
    height: 13.698,
    fill: "#0072ce"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Receive_Send_Term_Payment"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Receive_Send_Term_Payment",
    "data-name": "Receive/Send Term, Payment",
    clipPath: "url(#clip-Receive_Send_Term_Payment)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11802",
    "data-name": "Group 11802",
    transform: "translate(0.277 2.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11801",
    "data-name": "Group 11801",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22269",
    "data-name": "Path 22269",
    d: "M125.633,5.517a6.548,6.548,0,0,1-.4.569c-.233.286-.453.586-.662.889-.179.258-.378.5-.558.76-.247.355-.511.7-.77,1.046-.043.057-.074.047-.1,0-.146-.279-.409-.466-.566-.739a3.192,3.192,0,0,0-.309-.367c-.3-.37-.589-.744-.886-1.114-.212-.265-.43-.525-.643-.79-.057-.071-.1-.151-.156-.23.041-.036.089-.018.132-.018.44,0,.88,0,1.321,0,.176,0,.166,0,.131-.164a4.683,4.683,0,0,0-.482-1.147,7.445,7.445,0,0,0-.466-.714,4.412,4.412,0,0,0-.667-.734,5.482,5.482,0,0,0-3.04-1.4,4.857,4.857,0,0,0-2.224.216.2.2,0,0,1-.253-.061c-.214-.266-.5-.462-.707-.735A.2.2,0,0,0,114.3.75c-.058-.051-.166-.081-.156-.159.005-.041.124-.068.191-.1A5.574,5.574,0,0,1,115.66.11,6.272,6.272,0,0,1,117.1,0a8.12,8.12,0,0,1,1.449.208,6.663,6.663,0,0,1,1.276.466,5.657,5.657,0,0,1,1.2.734,5.977,5.977,0,0,1,.7.614,7.768,7.768,0,0,1,.811.979,6.07,6.07,0,0,1,.485.815,8.049,8.049,0,0,1,.533,1.412.446.446,0,0,1,.013.074c.016.212.016.212.231.212h1.838",
    transform: "translate(-108.186 0.001)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22270",
    "data-name": "Path 22270",
    d: "M0,97.464c.035-.051.053-.078.072-.105.123-.17.267-.322.375-.506.093-.159.229-.291.338-.442.172-.238.367-.462.524-.707.176-.273.4-.51.571-.784.152-.24.348-.455.512-.69.033-.047.059-.059.105-.006a3.047,3.047,0,0,1,.336.422,2.868,2.868,0,0,0,.25.3c.309.387.606.785.928,1.162.207.243.391.5.6.745.164.188.316.391.474.586-.028.041-.065.025-.1.025-.461,0-.923,0-1.384,0-.182,0-.182.017-.129.189.084.274.21.53.311.8a2.893,2.893,0,0,0,.379.655c.047.066.077.138.121.2a4.466,4.466,0,0,0,.6.716,6.266,6.266,0,0,0,.715.614,6.134,6.134,0,0,0,1.6.8,4.769,4.769,0,0,0,.988.188,5.139,5.139,0,0,0,1.19,0c.208-.024.413-.077.621-.109a2.409,2.409,0,0,0,.464-.113c.028-.01.061-.018.083.007.157.185.346.338.509.519.131.145.282.277.426.413.05.047.056.093-.017.109-.277.062-.53.19-.8.275a7.116,7.116,0,0,1-2.493.23,6.322,6.322,0,0,1-1.956-.469,6.131,6.131,0,0,1-1.4-.77,6.724,6.724,0,0,1-.718-.59,8.3,8.3,0,0,1-.714-.781,4.771,4.771,0,0,1-.546-.8,7.149,7.149,0,0,1-.483-1c-.105-.31-.2-.626-.277-.943-.029-.114-.076-.148-.187-.147-.576,0-1.151,0-1.727,0H0",
    transform: "translate(0 -89.277)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22271",
    "data-name": "Path 22271",
    d: "M130.446,61.386c.182,0,.364,0,.546,0,.07,0,.092.015.087.092a2.747,2.747,0,0,0,.062.653.369.369,0,0,0,.241.285.778.778,0,0,0,.75-.025.521.521,0,0,0,.17-.7,1.249,1.249,0,0,0-.328-.36c-.243-.181-.5-.337-.75-.511a5.01,5.01,0,0,1-1.016-.845,1.564,1.564,0,0,1-.359-.876,2.1,2.1,0,0,1,.088-.9,1.444,1.444,0,0,1,1.014-.9c.185-.056.186-.055.186-.251,0-.169,0-.339,0-.508,0-.066.017-.087.085-.087.347,0,.694,0,1.041,0,.086,0,.1.032.095.1,0,.2,0,.4,0,.6a.1.1,0,0,0,.086.116,1.484,1.484,0,0,1,.99.782,1.234,1.234,0,0,1,.139.43,5.536,5.536,0,0,1,.036.62c0,.086-.027.1-.107.1-.334,0-.669-.005-1,0-.088,0-.115-.021-.114-.112a1.061,1.061,0,0,0-.147-.616.676.676,0,0,0-1.049.015.609.609,0,0,0,.037.548,1.591,1.591,0,0,0,.422.433,8.155,8.155,0,0,0,.793.534,1.95,1.95,0,0,1,.322.264,2.728,2.728,0,0,1,.764.874,1.732,1.732,0,0,1,.112,1.264,1.422,1.422,0,0,1-.724.893,1.87,1.87,0,0,1-.463.157c-.072.019-.1.048-.095.119,0,.207,0,.415,0,.622,0,.074-.023.094-.094.093q-.52-.005-1.041,0c-.071,0-.084-.028-.083-.09,0-.186-.007-.373,0-.559.008-.126-.036-.173-.158-.2a1.318,1.318,0,0,1-.691-.345,1.807,1.807,0,0,1-.474-1.049,3.819,3.819,0,0,1-.025-.569c0-.07.023-.1.1-.094.186,0,.372,0,.559,0Z",
    transform: "translate(-123.021 -53.508)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22272",
    "data-name": "Path 22272",
    d: "M84.322,16.18a.12.12,0,0,1,.074.051c.237.262.513.486.739.759.051.061.17.1.161.172-.005.048-.122.087-.192.124a4.958,4.958,0,0,0-.88.564c-.025.021-.038.03-.068-.006a4.257,4.257,0,0,0-.385-.38c-.133-.121-.242-.269-.375-.392-.156-.146-.154-.143.015-.288.257-.221.561-.369.833-.566a.455.455,0,0,1,.077-.037",
    transform: "translate(-78.938 -15.336)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22273",
    "data-name": "Path 22273",
    d: "M211.781,215.655a3.715,3.715,0,0,0,.859-.465c.073-.048.128-.117.207-.161a.131.131,0,0,1,.178.009,2.236,2.236,0,0,1,.259.273c.178.184.382.341.545.541.053.065.045.091-.016.135-.2.146-.4.3-.609.444a4.07,4.07,0,0,1-.377.2.048.048,0,0,1-.067-.011c-.16-.2-.375-.346-.535-.549a4.2,4.2,0,0,0-.444-.418",
    transform: "translate(-200.735 -203.784)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22274",
    "data-name": "Path 22274",
    d: "M63.22,39.6a1.144,1.144,0,0,1-.139-.107c-.1-.1-.2-.2-.285-.3a3.408,3.408,0,0,0-.329-.311c-.019-.017-.036-.035-.054-.053-.149-.15-.146-.15-.024-.316.145-.2.328-.36.486-.545.042-.049.066-.049.117,0,.177.161.342.332.5.508.107.117.253.192.339.333.028.046.031.064,0,.1-.147.172-.323.317-.454.5-.036.051-.074.1-.111.152-.012.016-.019.039-.045.039",
    transform: "translate(-59.049 -35.948)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22275",
    "data-name": "Path 22275",
    d: "M243.063,192.625a.635.635,0,0,1,.069.064,2.021,2.021,0,0,0,.262.267c.193.167.343.38.544.541.056.045.066.083.013.145-.18.21-.35.429-.543.629-.07.072-.122.058-.175-.013a3.946,3.946,0,0,0-.439-.447c-.13-.124-.246-.265-.377-.39-.025-.024-.02-.041,0-.061a5.725,5.725,0,0,0,.6-.693.365.365,0,0,1,.047-.041",
    transform: "translate(-229.757 -182.578)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22276",
    "data-name": "Path 22276",
    d: "M51.005,62.966a1.515,1.515,0,0,1-.242-.218,1.742,1.742,0,0,0-.311-.328c-.133-.107-.223-.251-.35-.36a.105.105,0,0,1-.014-.164,1.218,1.218,0,0,0,.179-.329c.025-.075.062-.108.14-.029.273.282.553.558.834.832.046.045.041.072.019.127a3.405,3.405,0,0,1-.206.416c-.012.021-.015.05-.047.053",
    transform: "translate(-47.445 -58.285)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22277",
    "data-name": "Path 22277",
    d: "M261.168,172.856c.136.128.244.259.378.368a4.1,4.1,0,0,1,.318.34c.076.078.161.147.241.221.028.026.051.051.027.1-.077.151-.172.29-.262.432-.027.043-.051.034-.078,0-.185-.212-.405-.389-.592-.6-.087-.1-.194-.184-.286-.281-.02-.021-.048-.035-.024-.072a3.655,3.655,0,0,0,.278-.509",
    transform: "translate(-247.273 -163.84)",
    fill: "#0072ce"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiveSendTermPayment);
export default __webpack_public_path__ + "static/media/Receive-Send Term, Payment.ed6cfae9b7474aeda158d46ee60482fc.svg";
export { ForwardRef as ReactComponent };